import { useRef } from 'react';

const STORAGE_KEY = 'zeitwahl.sessionId';
const VALID = /^[A-Za-z0-9_-]{16,64}$/;

function generateSessionId(): string {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID().replace(/-/g, '');
    }
  } catch {
    // fall through to the weak generator
  }
  let s = '';
  while (s.length < 32) s += Math.random().toString(36).slice(2);
  return s.slice(0, 32);
}

/**
 * One id per browser tab so a reload (or a second widget on the same page) replaces the visitor's
 * previous hold instead of stacking a new one. Falls back to a per-mount id without storage.
 */
export function getOrCreateSessionId(): string {
  try {
    if (typeof sessionStorage === 'undefined') return generateSessionId();
    const existing = sessionStorage.getItem(STORAGE_KEY);
    if (existing && VALID.test(existing)) return existing;
    const id = generateSessionId();
    sessionStorage.setItem(STORAGE_KEY, id);
    return id;
  } catch {
    return generateSessionId();
  }
}

export function useSessionId(): string {
  const ref = useRef<string | null>(null);
  if (ref.current === null) ref.current = getOrCreateSessionId();
  return ref.current;
}
